'use client';
import { FC } from 'react';

import { useBreakpoint } from '@contexts/breakpoints';
import { SFHeaderFooterCategoryFooterViewModel } from '@api/index';

import { Wrapper } from './styled';
import DesktopHeader from './DesktopHeader/DesktopHeader';
import MobileHeader from './MobileHeader/MobileHeader';

export interface IBottomHeader {
  data?: SFHeaderFooterCategoryFooterViewModel['header'];
}

const BottomHeader: FC<IBottomHeader> = ({ data }) => {
  const { xl } = useBreakpoint();

  return (
    <Wrapper>
      {xl || xl === undefined ? (
        <DesktopHeader data={data} />
      ) : (
        <MobileHeader data={data} />
      )}
    </Wrapper>
  );
};

export default BottomHeader;
